export const ECARD_DEFAULT_WIDTH = 545;
export const ECARD_DEFAULT_HEIGHT = 775;
export const ECARD_MOBILE_HEIGHT = 500;
